module.exports = __webpack_public_path__ + "img/harmonyOS_bg1.ed7ec06e.jpg";